import { Swiper } from "swiper"
import { Pagination, EffectFade } from "swiper/modules"
import { getElements } from "@oddcamp/js-utils/src/selector"

import init from "../../shared/utils/init"

// swiper

init(() => {
  getElements(`.tags-carousel__inner`).forEach((containerEl) => {
    new Swiper(containerEl.querySelector(`.swiper`), {
      modules: [Pagination, EffectFade],
      effect: `fade`,
      crossFade: true,
      pagination: {
        el: `.swiper-pagination`,
        type: `bullets`,
        clickable: true,
      },
    })

    containerEl
      .querySelector(`.swiper-button-next`)
      .addEventListener(`click`, () => {
        if (
          containerEl.querySelector(`.swiper`).swiper.activeIndex ===
          containerEl.querySelector(`.swiper`).swiper.slides.length - 1
        ) {
          containerEl.querySelector(`.swiper`).swiper.slideTo(0)
          return
        }
        containerEl.querySelector(`.swiper`).swiper.slideNext()
      })

    containerEl
      .querySelector(`.swiper-button-prev`)
      .addEventListener(`click`, () => {
        if (containerEl.querySelector(`.swiper`).swiper.activeIndex === 0) {
          containerEl
            .querySelector(`.swiper`)
            .swiper.slideTo(
              containerEl.querySelector(`.swiper`).swiper.slides.length - 1
            )
          return
        }
        containerEl.querySelector(`.swiper`).swiper.slidePrev()
      })
  })
})
